export const TRACKING_EVENTS = Object.freeze({
	REGISTRATION: {
		APP: "registration",
		EVENT: {
			VALIDATION_ERROR: "validation_error",
			USER_INTERACTION: "user_interaction",
			REGISTRATION_COMPLETED: "registration_completed",
			LOYALTY_REGISTRATION_COMPLETED: "loyalty_registration",
			REGISTRATION_FAILED: "registration_failed",
			REGISTER_WITH_PROFILE_VERIFICATION: "register_with_profile_verification",
			SKIP_PROFILE_VERIFICATION: "skip_profile_verification",
			VERIFY_PROFILE: "verify_profile",
			PROFILE_VERIFICATION_FAILED: "profile_verification_failed",
			PROFILE_VERIFICATION_COMPLETED: "profile_verification_completed",
		},
	},
	LOGIN: {
		APP: "login",
		EVENT: {
			USER_INTERACTION: "user_interaction",
			CHECK_USERNAME_EXISTS: "user_exists",
			SMS_LOGIN_CODE_SENT: "sms_login_code_sent",
			SMS_LOGIN_CODE_VERIFIED: "sms_login_code_verified",
			SMS_LOGIN_CODE_VERIFICATION_FAILED: "sms_login_code_verification_failed",
			VERIFY_LOGIN: "verify_login",
			REGISTER_LINK_CLICK: "register_link_click",
			REQUEST_PASSWORDLESS_LOGIN: "request_passwordless_login",
		},
	},
	PASSWORD: {
		APP: "password",
		EVENT: {
			USER_INTERACTION: "user_interaction",
			RESET_PASSWORD_TRIGGERED: "reset_password_triggered",
			FORGOT_PASSWORD_EMAIL_SENT: "forgot_password_email_sent",
		},
	},
	COMMON: {
		EVENT: {
			USER_INTERACTION: "user_interaction",
			VIPPS_LOGIN_CLICKED: "vipps_login_clicked",
			REDIRECT_TO_LOGIN: "redirect_to_login",
			CHECK_USERNAME_EXISTS: "check_username_exists",
			USERNAME_EXISTS: "username_exists",
			USERNAME_NOT_EXISTS: "username_not_exists",
		},
	},
});
